import { api } from '../configs/axiosConfigs';

export const shareProperty = async ({ id, requestBody }) => {
  const requestUrl = `/properties/${id}/share`;
  return await api.post(requestUrl, requestBody);
};
